import { Grid, styled } from '@mui/material';

export const CascoHistoryContentWrapper = styled(Grid)(({ theme }) => ({
  '& .MuiChip-root, strong': {
    marginRight: theme.spacing(0.5)
  }
}));
